<template>
  <div>
    <h2 class="content-heading">
      <i class="si si-basket mr-5"></i> Uren registratie
    </h2>
    <button v-if="!hourRegistrationStarted" type="button" class="btn btn-success btn-lg" @click="startHourRegistration">Start urenregistratie</button>
    <button v-else type="button" class="btn btn-danger btn-lg" @click="stopHourRegistartion">Stop urenregistratie</button>
    
    <hour-registration-table ref="registrationTable" :userId="this.$auth.getUser().id" role="orderpicker"></hour-registration-table>
  </div>
</template>

<script>
import HourRegistrationTable from './HourRegistrationTable.vue'

export default {
  components: {
    HourRegistrationTable
  },
  data () {
    return {
      hourRegistrationStarted: false
    }
  },
  methods: {
    refresh () {
      this.$refs.registrationTable.refresh()
    },
    startHourRegistration () {
      this.$http.get(`/hour-registration/start`)
        .then((response) => {
          this.refresh()
          this.hourRegistrationStarted = true
        })
        .catch(() => {
          this.$swal('Oeps! 😳', `Er is iets fout bij het starten van de uren registratie Probeer het opnieuw.`, 'error')
        })
    },
    stopHourRegistartion () {
      this.$http.get(`/hour-registration/stop`)
        .then((response) => {
          this.refresh()
          this.hourRegistrationStarted = false
        })
        .catch(() => {
          this.$swal('Oeps! 😳', `Er is iets fout bij het stoppen van de uren registratie Probeer het opnieuw.`, 'error')
        })
    }
  },
  created () {
    this.$http.get(`/hour-registration/latest`)
    .then((response) => {
      if (!response.data.data.stopped_at) {
        this.hourRegistrationStarted = true
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// HourRegistrationPage.vue?35757231